export default __webpack_public_path__ + "static/why-choose-back-0f870b7c7f1ab500c6336f03795bf5ad.webp";